import type { PendingInvitation } from '@/lib/api'

export function getPendingTeamInvitationSummary(count: number): string {
  if (count <= 0) return 'No pending team invitations'
  if (count === 1) return '1 pending team invitation'
  return `${count} pending team invitations`
}

export function getPendingTeamInvitationDescription(invitations: Pick<PendingInvitation, 'teamName'>[]): string {
  const firstTeamName = invitations[0]?.teamName?.trim()
  if (!firstTeamName) return 'Review and respond to your pending team invitations.'
  if (invitations.length === 1) return `Review your invitation to join ${firstTeamName}.`
  return `Review your invitation to join ${firstTeamName} and ${invitations.length - 1} more.`
}
